import { render, staticRenderFns } from "./ProductsModal.vue?vue&type=template&id=2dcd62d4&scoped=true"
import script from "./ProductsModal.vue?vue&type=script&lang=js"
export * from "./ProductsModal.vue?vue&type=script&lang=js"
import style0 from "./ProductsModal.vue?vue&type=style&index=0&id=2dcd62d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd62d4",
  null
  
)

export default component.exports